const FEATURED_LINKS = {
    SHOP_MY_STORE_SID: 'FeaturedLink_ShopYourStore',
    SHOP_SAME_DAY_SID: 'FeaturedLink_ShopSameDay'
};

const COMPONENT_SIDS = {
    SHOP_MY_STORE_FROM_YOUR_BASKET: 'shop-store-happening_productlist_fromyourbasket',
    SHOP_MY_STORE_BUY_IT_AGAIN: 'shop-happening_productlist_buyitagain',
    SHOP_MY_STORE_FROM_YOUR_LOVES: 'shop-store-happening_productlist_fromyourloves',
    SHOP_MY_STORE_SERVICES: 'shop-store-happening-services-carousel',
    SHOP_MY_STORE_EVENTS: 'shop-store-happening-events-carousel',
    SHOP_MY_STORE_SEARCH: 'shop_your_store_search',
    SHOP_SAME_DAY_FROM_YOUR_BASKET: 'sameday-happening_productlist_fromyourbasket',
    SHOP_SAME_DAY_BUY_IT_AGAIN: 'sameday-happening_productlist_buyitagain',
    SHOP_SAME_DAY_FROM_YOUR_LOVES: 'sameday-happening_productlist_fromyourloves',
    SHOP_SAME_DAY_SEARCH: 'shop_same_day_search'
};

const COMPONENT_IDENTITY = {
    SEARCH_BAR: 'searchBar',
    SYS_FROM_YOUR_BASKET: 'shopYourStore_basket',
    SYS_FROM_YOUR_LOVES: 'shopYourStore_shoppingList',
    SYS_BUY_IT_AGAIN: 'shopYourStore_purchaseHistory',
    SYS_PRODUCT_LIST_BESTSELLERS: 'shopYourStore_constructorBestsellers',
    SYS_PRODUCT_LIST_NEW: 'shopYourStore_constructorNew',
    SYS_PRODUCT_LIST_SALE: 'shopYourStore_saleSearch',
    SYS_PRODUCT_LIST_CATEGORY: 'shopYourStore_category'
};

const NEW_BADGE = {
    EN: 'New',
    FR: 'Nouv'
};

const LANDING_PAGE = {
    TIMEOUT: 3000,
    ZIP_CODE_DETAILS: 'sameDay',
    STORE_DETAILS: 'storeDetails',
    MAX_ITEMS_FOR_RECAP: 4
};

const ELEMENTS_IDS = {
    SHOP_MY_STORE: 'shopMyStore',
    SHOP_SAME_DAY: 'shopSameDay',
    STORE_DETAILS: 'storeDetails',
    FIND_SEPHORA: 'findASephora',
    SERVICES_EVENTS: 'servicesAndEvents'
};

export {
    FEATURED_LINKS, COMPONENT_SIDS, COMPONENT_IDENTITY, NEW_BADGE, LANDING_PAGE, ELEMENTS_IDS
};
